export default "__VITE_ASSET__BTeY647U__"